import { render, staticRenderFns } from "./wsNotificationStack.vue?vue&type=template&id=6bb39076&scoped=true&"
import script from "./wsNotificationStack.vue?vue&type=script&lang=js&"
export * from "./wsNotificationStack.vue?vue&type=script&lang=js&"
import style0 from "./wsNotificationStack.vue?vue&type=style&index=0&id=6bb39076&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb39076",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VIcon,VSheet})
